import React, { type JSX } from 'react';
import { CustomPlaceholder } from './CustomPlaceHolder';
import { IconButton, InputBase, Stack } from '@mui/material';
import { Search } from '@mui/icons-material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const InputWithCustomPlaceholder = ({
    placeholder,
    value,
    onChange,
    inputProps,
    ...props
}: any): JSX.Element => {
    const [hasValue, setHasValue] = React.useState(false);

    const handleClear = (): void => {
        onChange?.({ target: { value: '' } });
        setHasValue(false);
    };

    return (
        <Stack
            direction="row"
            alignItems="center"
            className={`${props?.noBorders ? 'w-100' : 'border-1 border-radius-4'}`}
            sx={{ height: '40px', maxWidth: props?.maxWidth ?? 250, width: '100%', ...props.sx }}
            aria-label={inputProps?.['aria-label']}
            data-testid={inputProps?.['data-testid']}
        >
            {!props?.noGlobalSearch && (
                <IconButton className="padding-10 color-content f-16" aria-label="search">
                    <Search />
                </IconButton>
            )}

            <Stack className="w-100" sx={{ position: 'relative', flex: 1 }}>
                <CustomPlaceholder hasValue={hasValue} placeholder={placeholder} />
                <InputBase
                    id="searchKey"
                    {...(value !== undefined && {
                        value: value ?? '',
                    })}
                    onChange={(e) => {
                        onChange?.(e);
                    }}
                    onFocus={() => setHasValue(true)}
                    onBlur={(e) => setHasValue(e.target.value.length > 0)}
                    className={`f-16 fw-600 w-100 padding-x-8 ${hasValue ? 'padding-y-12' : ''}`}
                    inputProps={{ 'aria-label': 'search', ...inputProps }}
                    endAdornment={
                        <IconButton aria-label="toggle password visibility" edge="end" onClick={handleClear}>
                            {value?.length > 0 ? <HighlightOffIcon /> : <></>}
                        </IconButton>
                    }
                />
            </Stack>
        </Stack>
    );
};
